import { PathWithId } from "@constellation-academy/epic-ui";

export class DiscountCodePath extends PathWithId<typeof DiscountCodePath> {
	static readonly pathKey = "discountCode";
	static readonly pathName = "discount-code";
	static readonly idKey = "discountCodeId";
}
